import React from "react";
import { Route } from "react-router-dom";
import HomePage from "../Screens/Homepage";
import MentorDetails from "../Screens/MentorDetails/index";
import SignUp from "../Screens/SignUp/index";
import MyProfile from "../Screens/MyProfile";
import ForgotPass from "../Screens/ForgotPassword/index";
import PaymentDetails from "../Screens/PaymentDetails/index";
import UpdatePaymentDetails from "../Screens/UpdatePaymentDetails/index";
import ShowPaymentDetails from "../Screens/ShowPaymentDetails/index";
import ChatBox from "../Screens/Chatbox/index";
import PreviousAppointment from "./../Components/PreviousAppointment";
import SignIn from "../Components/Pages/Authentication/LoginForm";
import Avalability from "../Screens/Avalability/index";
import Feedback from "../Screens/Feedback/index";
import ConsulationType from "../Screens/Consulation/index";
import Option from "./../Screens/option/index";
import Appointments from "../Screens/Appointments/index";
import CancleAppointmentrequest from "../Screens/CancleAppointmentRequest/index";
import SelectTimeSlot from "../Screens/SelectTimeSlot/index";
import Options from "./../Screens/option/index";
import MenteeProfile from "./MenteeProfile";
import MentorDefineAvaalbilty from "../Screens/MentorDefineAvaalbilty/index";
import MenteeSelectTimeSlote from "../Screens/MenteeSelectTimeSlot/index";
import Dashboard from "../Screens/Dashboard/index";
import MentorProfile from "../Screens/MentorProfile/index";
import Schedule1 from "../Screens/ScheduleAppointment/Appointment1";
import Schedule3 from "../Screens/ScheduleAppointment/Appointment3";
import Schedule4 from "../Screens/ScheduleAppointment/Appointment4";
import Schedule5 from "../Screens/ScheduleAppointment/Appointment5";
import Schedule6 from "../Screens/ScheduleAppointment/Appointment6";
import PreviousAppointments from "./../Screens/PreviousAppointments/index";
import UpcomingAppointments from "./../Screens/UpcomingAppointments/index";
import MoreUpcomingAppointments from "./../Screens/MoreUpcomingAppointments/index";
import MorePreviousAppointments from "./../Screens/MorePreviousAppointments/index";
import MyAppointments from "./../Screens/MyAppointments";
import MentorDetailsDialog from "../Screens/Homepage/MentorDetailsDialog";
import MyOffers from "../Screens/Offers";
// v2 components
import signupV2 from "../Screens/SignupV2";
import UserInfo from "../Screens/UserInfo/UserInfo";
import { NewAppointment } from "../Screens/NewAppointment";
import ZoomFeedback from "../Screens/MeetingFeedback/index";
import PaymentStatus from "../Screens/NewAppointment/PaymentStatus";

export const mapStageToRoute = (stage) => {
  switch (stage) {
    case "PAYMENT_DETAILS":
      return "paymentdetails";
    default:
      return "null";
  }
};
// QwertWstah1235

export default [
  <Route
    exact
    path="/mentorprofile/:mentorId"
    component={MentorProfile}
    noLayout
  />,
  <Route exact path="/" component={HomePage} noLayout />,
  <Route  path="/myprofile" component={MyProfile} noLayout />,
  <Route path="/signup/:user" component={SignUp} noLayout />,
  <Route
    exact
    path="/PreviousAppointment/:user"
    component={PreviousAppointment}
    noLayout
  />,
  <Route exact path="/forgotpassword" component={ForgotPass} noLayout />,
  <Route exact path="/paymentdetails" component={PaymentDetails} noLayout />,
  <Route
    exact
    path="/showpaymentdetails"
    component={ShowPaymentDetails}
    noLayout
  />,
  <Route
    exact
    path="/updatepaymentdetails"
    component={UpdatePaymentDetails}
    noLayout
  />,
  <Route exact path="/schedule3" component={Schedule3} noLayout />,
  <Route exact path="/schedule4" component={Schedule4} noLayout />,
  <Route exact path="/schedule5" component={Schedule5} noLayout />,
  <Route exact path="/schedule6" component={Schedule6} noLayout />,
  <Route exact path="/schedule1" component={Schedule1} noLayout />,
  <Route exact path="/chatbox" component={ChatBox} noLayout />,
  <Route exact path="/login" component={SignIn} noLayout />,
  <Route exact path="/avalability" component={Avalability} noLayout />,
  <Route exact path="/feedback" component={Feedback} noLayout />,
  <Route exact path="/consulationtype" component={ConsulationType} noLayout />,
  <Route exact path="/appointments" component={Appointments} noLayout />,
  <Route
    exact
    path="/cancleappointmentrequest"
    component={CancleAppointmentrequest}
    noLayout
  />,
  <Route exact path="/selecttimeslot" component={SelectTimeSlot} noLayout />,
  <Route exact path="/menteeProfile" component={MenteeProfile} noLayout />,
  <Route
    exact
    path="/menteeSelectTimeSlote"
    component={MenteeSelectTimeSlote}
    noLayout
  />,
  <Route exact path="/Option" component={Option} noLayout />,
  <Route exact path="/Dashboard" component={Dashboard} noLayout />,
  <Route exact path="/option" component={Options} noLayout />,
  <Route
    exact
    path="/UpcomingAppointments"
    component={UpcomingAppointments}
    noLayout
  />,
  <Route
    exact
    path="/PreviousAppointments"
    component={PreviousAppointments}
    noLayout
  />,
  <Route
    exact
    path="/moreupcomingappointments"
    component={MoreUpcomingAppointments}
    noLayout
  />,
  <Route
    exact
    path="/morePreviousAppointments"
    component={MorePreviousAppointments}
    noLayout
  />,
  <Route
    exact
    path="/MentorDefineAvaalbilty"
    component={MentorDefineAvaalbilty}
    noLayout
  />,
  <Route
    exact
    path="/MentorDetails/:mentorId"
    component={MentorDetails}
    noLayout
  />,
  <Route exact path="/v2/signup" component={signupV2} noLayout />,
  <Route exact path="/user-info/linkedin" component={UserInfo} noLayout />,
  <Route exact path="/user-info/" component={UserInfo} noLayout />,
  <Route
    exact
    path="/new-appointment/:mentorId"
    component={NewAppointment}
    noLayout
  />,
  <Route exact path="/my-appointments" component={MyAppointments} noLayout />,
  <Route
    exact
    path="/mentor-details/:mentorId"
    component={MentorDetailsDialog}
    noLayout
  />,
  <Route
    exact
    path="/zoom-meeting-feedback"
    component={ZoomFeedback}
    noLayout
  />,
  <Route exact path="/payment-status" component={PaymentStatus} noLayout />,
  <Route  path="/myoffers" component={MyOffers} noLayout />,
  

];
